import { css } from '@emotion/react';
import styled from '@emotion/styled';

import Button from 'components/field/Button';

import { Breakpoints } from 'utils/const.styles';

export const TopBarContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;

	position: sticky;
	z-index: var(--z-index-8);
	background: var(--white);
	border-bottom: 1px solid var(--border-color);
	height: var(--topBarHeight);

	@media ${Breakpoints.mobile} {
		height: ${({ isSearchOrderOpen }) =>
			isSearchOrderOpen ? 'calc(var(--topBarHeight) * 2)' : 'var(--topBarHeight)'};
	}
`;

export const TopBar = styled.header`
	display: flex;
	top: 0;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding: 0 var(--padding-3);
	height: var(--topBarHeight);

	@media ${Breakpoints.mobile} {
		padding: 0 var(--padding-3);
	}
`;

export const TopbarRightSide = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	gap: 2.7rem;

	@media ${Breakpoints.mobile} {
		align-items: center;
	}

	> .add-order-button,
	> .charge-account-button {
		@media ${Breakpoints.mobileLandscape} {
			.button-text {
				display: none;
			}
		}
	}

	> .add-order-button {
		@media (max-width: 324px) {
			display: none;
		}
	}

	.typography.remaining-amount-text {
		@media ${Breakpoints.mobileLandscape} {
			font-size: var(--paragraph3-font-size);
		}
	}

	div.mobileHelpButton {
		display: none;
		width: 3rem;

		@media ${Breakpoints.mobileLandscape} {
			display: flex;
		}
	}
	.notification-badge {
		pointer-events: none;
	}

	> .topbar-button {
		height: 4.1rem;
		padding: 0.7rem;

		body[dir='rtl'] & {
			padding: 0.4rem 1rem;
		}
	}
`;

export const TopbarLeftSide = styled.div`
	display: flex;
	align-items: center;
`;

export const TopbarToggleBtn = styled.div`
	display: none;
	color: var(--black);
	width: ${({ isopen }) => (!isopen ? '0' : '100%')};

	@media ${Breakpoints.mobile} {
		display: ${({ isopen }) => (!isopen ? 'block' : 'none')};
	}
`;

export const NotificationButtonCss = css`
	padding: 0 !important;

	> .icon {
		:hover,
		:focus {
			animation: shake 0.5s infinite;
		}
	}
	svg {
		width: 3.2rem !important;
		padding: 0 !important;
	}
`;

export const Divider = styled.div`
	display: flex;
	align-self: stretch;
	width: 1px;
	background: var(--border-color);
	margin: 0.5rem 0;

	&.mobile-help-button-divider {
		display: none;

		@media ${Breakpoints.mobileLandscape} {
			display: flex;
		}
	}
`;

export const DashedButton = styled(Button)`
	&.dashed {
		background: transparent;
		border: 1px dashed var(--border-color-variation);
		:not(.disabled):hover {
			background: var(--actionButtonColor);
			color: var(--blue-hover);

			.button-text,
			.button-icon {
				color: ${({ color }) => color};
				filter: brightness(1.2);
			}
		}

		.button-text,
		.button-icon {
			color: ${({ color }) => color};
		}
	}
`;

export const SearchBarContainer = styled.div`
	width: 100%;
	border-top: 1px solid var(--border-color);
	padding: var(--padding-2);
`;
